import { ACCOUNTING_CONFIG } from 'shared';

import { useGetSelectedOrganisation } from './useGetSelectedOrganisation';
import { useAccountingSystemSetting } from './useAccountingSystemSetting';

export function useAccountingSystemTaxApplicability() {
  const organisation = useGetSelectedOrganisation();
  const applicable = useAccountingSystemSetting(ACCOUNTING_CONFIG.TAX_INCLUSIVE_APPLICABLE);

  // QBO US is always exclusive
  return Boolean(applicable) && !(organisation?.type === `QBO` && organisation?.region === `US`);
}
